/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentOrderViewPaypalPaymentRequestFromJSON, PaymentOrderViewPaypalPaymentRequestToJSON, } from './PaymentOrderViewPaypalPaymentRequest';
import { PaymentOrderViewBlikPaymentRequestFromJSON, PaymentOrderViewBlikPaymentRequestToJSON, } from './PaymentOrderViewBlikPaymentRequest';
import { ContactDetailsFromJSON, ContactDetailsToJSON, } from './ContactDetails';
import { PaymentOrderViewAvailableCreditBalancesInnerFromJSON, PaymentOrderViewAvailableCreditBalancesInnerToJSON, } from './PaymentOrderViewAvailableCreditBalancesInner';
import { PaymentOrderViewGooglePayPaymentRequestFromJSON, PaymentOrderViewGooglePayPaymentRequestToJSON, } from './PaymentOrderViewGooglePayPaymentRequest';
import { StoredCardFromJSON, StoredCardToJSON, } from './StoredCard';
import { PaymentOrderViewApplePayPaymentRequestFromJSON, PaymentOrderViewApplePayPaymentRequestToJSON, } from './PaymentOrderViewApplePayPaymentRequest';
import { CommonBookingInfoViewFromJSON, CommonBookingInfoViewToJSON, } from './CommonBookingInfoView';
/**
 * @export
 */
export const PaymentOrderViewAvailablePaymentMethodsEnum = {
    ApplePay: 'apple_pay',
    Blik: 'blik',
    Card: 'card',
    Credits: 'credits',
    Ideal: 'ideal',
    GooglePay: 'google_pay',
    Paypal: 'paypal',
    Promocode: 'promocode',
    Revolut: 'revolut',
    Volt: 'volt'
};
/**
 * @export
 */
export const PaymentOrderViewSuccessPageTypeEnum = {
    Mmb: 'mmb',
    FareLock: 'fare_lock',
    Subscription: 'subscription'
};
/**
 * Check if a given object implements the PaymentOrderView interface.
 */
export function instanceOfPaymentOrderView(value) {
    if (!('availableCreditBalances' in value) || value['availableCreditBalances'] === undefined)
        return false;
    if (!('availablePaymentMethods' in value) || value['availablePaymentMethods'] === undefined)
        return false;
    if (!('contactDetails' in value) || value['contactDetails'] === undefined)
        return false;
    if (!('isBillingInfoRequired' in value) || value['isBillingInfoRequired'] === undefined)
        return false;
    if (!('isSandbox' in value) || value['isSandbox'] === undefined)
        return false;
    if (!('isSubscriptionConsentRequired' in value) || value['isSubscriptionConsentRequired'] === undefined)
        return false;
    if (!('storedCards' in value) || value['storedCards'] === undefined)
        return false;
    if (!('successPageType' in value) || value['successPageType'] === undefined)
        return false;
    return true;
}
export function PaymentOrderViewFromJSON(json) {
    return PaymentOrderViewFromJSONTyped(json, false);
}
export function PaymentOrderViewFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'applePayPaymentRequest': json['apple_pay_payment_request'] == null ? undefined : PaymentOrderViewApplePayPaymentRequestFromJSON(json['apple_pay_payment_request']),
        'availableCreditBalances': (json['available_credit_balances'].map(PaymentOrderViewAvailableCreditBalancesInnerFromJSON)),
        'availablePaymentMethods': json['available_payment_methods'],
        'blikPaymentRequest': json['blik_payment_request'] == null ? undefined : PaymentOrderViewBlikPaymentRequestFromJSON(json['blik_payment_request']),
        'common': json['common'] == null ? undefined : CommonBookingInfoViewFromJSON(json['common']),
        'contactDetails': ContactDetailsFromJSON(json['contact_details']),
        'googlePayPaymentRequest': json['google_pay_payment_request'] == null ? undefined : PaymentOrderViewGooglePayPaymentRequestFromJSON(json['google_pay_payment_request']),
        'isBillingInfoRequired': json['is_billing_info_required'],
        'isSandbox': json['is_sandbox'],
        'isSubscriptionConsentRequired': json['is_subscription_consent_required'],
        'paypalPaymentRequest': json['paypal_payment_request'] == null ? undefined : PaymentOrderViewPaypalPaymentRequestFromJSON(json['paypal_payment_request']),
        'storedCards': (json['stored_cards'].map(StoredCardFromJSON)),
        'successPageType': json['success_page_type'],
    };
}
export function PaymentOrderViewToJSON(json) {
    return PaymentOrderViewToJSONTyped(json, false);
}
export function PaymentOrderViewToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'apple_pay_payment_request': PaymentOrderViewApplePayPaymentRequestToJSON(value['applePayPaymentRequest']),
        'available_credit_balances': (value['availableCreditBalances'].map(PaymentOrderViewAvailableCreditBalancesInnerToJSON)),
        'available_payment_methods': value['availablePaymentMethods'],
        'blik_payment_request': PaymentOrderViewBlikPaymentRequestToJSON(value['blikPaymentRequest']),
        'common': CommonBookingInfoViewToJSON(value['common']),
        'contact_details': ContactDetailsToJSON(value['contactDetails']),
        'google_pay_payment_request': PaymentOrderViewGooglePayPaymentRequestToJSON(value['googlePayPaymentRequest']),
        'is_billing_info_required': value['isBillingInfoRequired'],
        'is_sandbox': value['isSandbox'],
        'is_subscription_consent_required': value['isSubscriptionConsentRequired'],
        'paypal_payment_request': PaymentOrderViewPaypalPaymentRequestToJSON(value['paypalPaymentRequest']),
        'stored_cards': (value['storedCards'].map(StoredCardToJSON)),
        'success_page_type': value['successPageType'],
    };
}
